export default {
  default: {
    readPercentage: 'Viewed {readPercentage}% of document in',
  },
}
